import topicsDir from "../__topicsDir";

/**
 * events data
 * イベント一覧データ
 * @props {string} date 日時（YYYY-MM-DD\THH:mm）
 * @props {string} title タイトル（html）
 * @props {string} [href] リンクURL
 */
export default [
	{
		date: "2021-06-22T12:00",
		title: `
<h4>新潟県医師会在宅医療推進センター（基幹センター）より</h4>
<p class="paragraph-indent">
●「令和2年度地域医療提供体制ならびに医療・介護連携に関する実態・意識調査」で得たデータをもとに、新潟大学と共同研究を行います。<br>
なお、新潟大学へ提供するデータは、回答者名及び医療機関名を削除したものとし、個人が特定されることはございませんが、研究にあたって回答データの使用を希望されない場合は、当センターまでご連絡ください。<br>
・<a href="${topicsDir}/2021/06-niigata_univ-format-for-optout.pdf">新潟大学 人を対象とする研究等倫理審査委員会 オプトアウト書式</a>
</p>
		`.trim().replace(/\t|\n/g, "")
	}
];
